import * as React from "react";
import { useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from "@material-ui/core";
import { Formik } from "formik";
import SendIcon from "@mui/icons-material/Send";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import PropTypes from "prop-types";
import PriceChangeIcon from "@material-ui/icons/PriceChangeOutlined";
import dayjs from "dayjs";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import useCreditManagement from "../../hooks/useCreditManagement";
import { extend } from "../../validations/credit";
import CustomDialogTitle from "../../components/common/CustomDialogTitle";

const Detail = ({ open, handleClose, data, tab }) => {
  const [value, setValue] = React.useState(tab);
  const {
    loading,
    // loadingDetail,
    creditDetail,
    credit,
    getListTransactions,
    listTrans = [],
    updateListTrans,
    updateTransaction,
    creditClose,
    creditTransform
    // handleCloseCat
  } = useCreditManagement();
  useEffect(() => {
    creditDetail(data.id);
    getListTransactions(data.id);
  }, [open, data.id]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const fromTime = dayjs(credit.loanDate).format("DD/MM/YYYY");
  const toTime = dayjs(credit.loanDate)
    .add(credit.numberPeriod, "day")
    .format("DD/MM/YYYY");
  const status = {
    closed: "Đóng hợp đồng",
    ontime: "Đến ngày đóng họ",
    pending: "Đang vay",
    late: "Chậm họ",
    expired: "Quá hạn",
    lastday: "Ngày cuối họ",
    deleted: "Đã xóa"
  };
  const contractReference = `${credit && credit.id ? `TC-${credit.id}` : ""}`;
  return (
    <>
      <div>
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
          <CustomDialogTitle
            title={`Bảng chi tiết hợp đồng tín chấp ${contractReference}`}
            handleClose={handleClose}
          />
          <>
            {loading ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress color="secondary" />
              </div>
            ) : (
              <DialogContent>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={6}>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{
                          "& .MuiTableRow-root:hover": {
                            backgroundColor: "table.hover"
                          },
                          "& .MuiTableCell-root": {
                            borderLeft:
                              "1px solid rgba(224, 224, 224, 1)!important"
                          }
                        }}
                        aria-label="simple table"
                      >
                        <TableBody>
                          <TableRow>
                            <TableCell component="th" scope="row" colSpan={3}>
                              {credit.customerName}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Tín chấp
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              align="right"
                              colSpan={3}
                            >
                              {credit && credit.loanAmount
                                ? credit.loanAmount.toLocaleString("en-US")
                                : 0}{" "}
                              VNĐ
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Tài sản
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              align="right"
                              colSpan={3}
                            >
                              {credit.collateralType}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Họ từ ngày
                            </TableCell>
                            <TableCell component="th" scope="row" align="right">
                              {fromTime}
                            </TableCell>
                            <TableCell component="th" scope="row" align="right">
                              {toTime}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  <Grid item xs={6}>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{
                          "& .MuiTableRow-root:hover": {
                            backgroundColor: "table.hover"
                          },
                          "& .MuiTableCell-root": {
                            borderLeft:
                              "1px solid rgba(224, 224, 224, 1)!important"
                          }
                        }}
                        aria-label="simple table"
                      >
                        <TableBody>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Tổng tiền phải đóng
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              align="right"
                              colSpan={2}
                            >
                              {credit && credit.loanAmount
                                ? credit.loanAmount.toLocaleString("en-US")
                                : 0}{" "}
                              VNĐ
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Lãi đã đóng
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              align="right"
                              colSpan={2}
                            >
                              {(credit.paidInterest || 0).toLocaleString(
                                "en-US"
                              )}{" "}
                              VNĐ
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Lãi đến hôm nay
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              align="right"
                              colSpan={2}
                            >
                              {(credit.interestToToday || 0).toLocaleString(
                                "en-US"
                              )}{" "}
                              VNĐ
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell component="th" scope="row">
                              Trạng thái
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              align="right"
                              colSpan={2}
                            >
                              {credit.status ? status[credit.status] : ""}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab
                          label="Lịch sử đóng tiền"
                          value="1"
                          icon={<PriceChangeIcon />}
                          iconPosition="start"
                        />
                        <Tab
                          label="Đóng HĐ"
                          value="2"
                          icon={<PriceChangeIcon />}
                          iconPosition="start"
                        />
                        <Tab
                          label="Gia hạn"
                          value="3"
                          icon={<PriceChangeIcon />}
                          iconPosition="start"
                        />
                      </TabList>
                    </Box>
                    <TabPanel value="1" sx={{ p: 0, mt: 1 }}>
                      <TableContainer component={Paper}>
                        <Table
                          aria-label="simple table"
                          sx={{
                            "& .MuiTableRow-root:hover": {
                              backgroundColor: "table.hover"
                            },
                            "& .MuiTableCell-root": {
                              borderLeft:
                                "1px solid rgba(224, 224, 224, 1)!important"
                            }
                          }}
                        >
                          <TableHead>
                            <TableRow
                              sx={{
                                backgroundColor: "#f4f3f7"
                              }}
                            >
                              <TableCell>STT</TableCell>
                              <TableCell align="right">Ngày</TableCell>
                              <TableCell align="right">Số ngày</TableCell>
                              <TableCell align="right">Tiền lãi</TableCell>
                              <TableCell align="right">Tiền khác</TableCell>
                              <TableCell align="right">Tổng lãi</TableCell>
                              <TableCell align="right">
                                Tiền khách trả
                              </TableCell>
                              <TableCell align="right">Chức năng</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {listTrans.map((row, index) => (
                              <TableRow key={row.id}>
                                <TableCell component="th" scope="row">
                                  {index + 1}
                                </TableCell>
                                <TableCell align="right">
                                  {dayjs(row.dateFrom).format("DD/MM/YYYY")}
                                  <ArrowForwardOutlinedIcon
                                    sx={{ fontSize: 16 }}
                                  />
                                  {dayjs(row.dateTo).format("DD/MM/YYYY")}
                                </TableCell>
                                <TableCell align="right">
                                  {row.numberDays}
                                </TableCell>
                                <TableCell align="right">
                                  {`${row.amountEstimate.toLocaleString(
                                    "en-US"
                                  )} VNĐ`}
                                </TableCell>
                                <TableCell align="right">
                                  {row.otherAmountEstimate.toLocaleString(
                                    "en-US"
                                  )}
                                </TableCell>
                                <TableCell align="right">
                                  {row.totalAmountEstimate.toLocaleString(
                                    "en-US"
                                  )}
                                </TableCell>
                                <TableCell align="right">
                                  {row.isPaid ? (
                                    <div>
                                      {`${row.amount.toLocaleString(
                                        "en-US"
                                      )} VNĐ`}
                                    </div>
                                  ) : (
                                    <TextField
                                      size="small"
                                      margin="normal"
                                      value={
                                        row.amount === 0
                                          ? row.amountEstimate.toLocaleString(
                                              "en-US"
                                            )
                                          : row.amount.toLocaleString("en-US")
                                      }
                                      type="text"
                                      fullWidth
                                      disabled={credit.status === "closed"}
                                      variant="outlined"
                                      onChange={event => {
                                        updateListTrans(
                                          row.id,
                                          "amount",
                                          event.target.value
                                        );
                                      }}
                                    />
                                  )}
                                </TableCell>
                                <TableCell align="right">
                                  <Tooltip
                                    title={
                                      row.isPaid
                                        ? "Hủy đã thu tiền"
                                        : "Đánh dấu đã thu tiền"
                                    }
                                    placement="top"
                                  >
                                    <Checkbox
                                      {...label}
                                      defaultChecked={row.isPaid}
                                      disabled={credit.status === "closed"}
                                      onChange={event => {
                                        const paidDate = row.paidDate
                                          ? row.paidDate
                                          : row.date;
                                        const updateData = {
                                          isPaid: event.target.checked,
                                          amount:
                                            row.amount === 0
                                              ? row.amountEstimate
                                              : row.amount,
                                          paidDate: dayjs(paidDate).format(
                                            "YYYY-MM-DD"
                                          )
                                        };
                                        updateTransaction(
                                          row.unsecuredLoanId,
                                          row.id,
                                          updateData
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </TabPanel>
                    <TabPanel value="2">
                      <Box>Chú ý:</Box>
                      <Box className="mb-3">
                        Số kỳ còn phải đóng :{" "}
                        {credit && credit.paidAmount && credit.loanAmount
                          ? (
                              credit.loanAmount - credit.paidAmount
                            ).toLocaleString("en-US")
                          : 0}{" "}
                        VNĐ
                      </Box>
                      {/* <Box>Nợ cũ : 0 VNĐ</Box> */}
                      <Button
                        autoFocus
                        variant="contained"
                        size="small"
                        onClick={async () => {
                          await creditClose(credit.id, handleClose);
                        }}
                        disabled={credit.status === "closed"}
                        startIcon={<SendIcon />}
                      >
                        Đóng hợp đồng
                      </Button>
                    </TabPanel>
                    <TabPanel value="3">
                      <Formik
                        initialValues={{
                          customerName: credit.customerName,
                          numberPeriod: 0,
                          notes: ""
                        }}
                        validationSchema={extend()}
                        onSubmit={async values => {
                          await creditTransform(values, credit, handleClose);
                          // handleClose();
                        }}
                      >
                        {({
                          errors,
                          touched,
                          isValid,
                          isSubmitting,
                          values,
                          handleSubmit,
                          setFieldValue
                        }) => (
                          <>
                            <Grid
                              container
                              spacing={0}
                              direction="row"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Grid container spacing={2}>
                                <Grid item sm={12} md={2} />
                                <Grid item sm={12} md={4}>
                                  <TextField
                                    label="Tên khách hàng"
                                    size="small"
                                    value={values.customerName}
                                    fullWidth
                                    margin="normal"
                                    readyOnly
                                    slotProps={{
                                      input: {
                                        readOnly: true
                                      }
                                    }}
                                  />
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid item sm={12} md={2} />
                                <Grid item sm={12} md={4}>
                                  <TextField
                                    error={Boolean(
                                      touched.numberPeriod &&
                                        errors.numberPeriod
                                    )}
                                    helperText={
                                      touched.numberPeriod &&
                                      errors.numberPeriod
                                    }
                                    onChange={event => {
                                      setFieldValue(
                                        "numberPeriod",
                                        parseInt(event.target.value)
                                      );
                                    }}
                                    size="small"
                                    margin="normal"
                                    id="numberPeriod"
                                    value={values.numberPeriod || 0}
                                    label="Gia hạn thêm"
                                    type="text"
                                    fullWidth
                                    required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          Ngày
                                        </InputAdornment>
                                      )
                                    }}
                                  />
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid item sm={12} md={2} />
                                <Grid item sm={12} md={4}>
                                  <TextField
                                    error={Boolean(
                                      touched.notes && errors.notes
                                    )}
                                    helperText={touched.notes && errors.notes}
                                    size="small"
                                    margin="normal"
                                    id="notes"
                                    onChange={event => {
                                      setFieldValue(
                                        "notes",
                                        event.target.value
                                      );
                                    }}
                                    value={values.notes}
                                    label="Ghi chú"
                                    type="text"
                                    fullWidth
                                    multiline
                                    rows={5}
                                    variant="outlined"
                                  />
                                </Grid>
                              </Grid>
                              <Grid container spacing={2} sx={{ mt: 1 }}>
                                <Grid item sm={12} md={2} />
                                <Grid item sm={12} md={6}>
                                  <Button
                                    autoFocus
                                    variant="contained"
                                    size="small"
                                    disabled={
                                      !isValid ||
                                      isSubmitting ||
                                      credit.status === "closed"
                                    }
                                    onClick={handleSubmit}
                                    startIcon={<SendIcon />}
                                  >
                                    Đồng ý
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </Formik>
                    </TabPanel>
                  </TabContext>
                </Box>
              </DialogContent>
            )}
          </>

          <DialogActions
            sx={{
              borderTop: "1px solid rgba(224, 224, 224, 1)"
            }}
            className="justify-start"
          >
            <Grid container spacing={2}>
              <Grid item sm={12} md={12}>
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  sx={{
                    marginLeft: 2
                  }}
                  size="small"
                >
                  Đóng
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

Detail.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  data: PropTypes.object,
  tab: PropTypes.string
};

export default Detail;
